export default {
    version: '1.0-beta1'
};
